<app-page-header
  class="header"
  [inside]="true"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="back.emit()"
/>

<div class="content">
  <span class="title">Enjoyed<br>Your Visit?</span>
  <span class="description">
    We’d love to hear from you. Scan the QR Code to leave a
    <span class="green">Google Review!</span>
  </span>
  <div class="link">
    <app-qrcode content="https://oon.gl/EdT5pw" [size]="278"/>
  </div>
</div>
